// ファイル選択 から アップロード／削除 までするコンポーネント
<template>
  <b-form-group :label="label" label-align="left">
    <!-- Mobileレイアウト -->
    <div v-if="isMobile" class="d-flex justify-content-left">
      <b-button
        :disabled="disabled"
        :class="`pc-file-form-button mb-1 ${disabled ? 'not-allowed' : ''}`"
        size="sm"
      >
        <label
          class="d-flex align-items-center mb-0 p-1"
          v-b-popover.hover.top="
            allow_attachment ? '' : 'この組織ではファイル添付が禁止されています'
          "
          v-on:click="clickMobile"
          :style="attachementLabelStyle"
        >
          撮影またはファイルを選択
        </label>
      </b-button>
      <div class="invisible-inputs">
        <input
          ref="album"
          type="file"
          :multiple="multiple ? true : undefined"
          :accept="contentType === 'TOPIC' ? accept(['image/*']) : accept()"
          :disabled="disabled"
          v-on:change="addFile"
        />
        <input
          ref="photo"
          type="file"
          capture
          :accept="captureAccept()"
          :disabled="disabled"
          v-on:change="addFile"
        />
        <input
          ref="video"
          type="file"
          capture
          :accept="videoAccept()"
          :disabled="disabled"
          v-on:change="addFile"
        />
      </div>
      <!-- 選択メニュー -->
      <b-modal ref="showMenu" hide-header hide-footer centered content-class="select-menu">
        <ul>
          <li @click.prevent="menuSelected('album')">ファイルから選択</li>
          <li v-if="allow_attachment_type.image" @click.prevent="menuSelected('photo')">
            写真を撮る
          </li>
          <li v-if="allow_attachment_type.movie" @click.prevent="menuSelected('video')">
            ビデオを撮る
          </li>
        </ul>
      </b-modal>
    </div>
    <!-- コメントのレイアウト -->
    <div v-else-if="contentType == 'COMMENT'" class="d-flex flex-row">
      <b-button
        :disabled="disabled"
        :class="attachmentLinkClass + ' mr-2 pl-0'"
        variant="outline"
        size="sm"
      >
        <label
          class="d-flex align-items-center mb-0"
          v-b-popover.hover.top="
            allow_attachment ? '' : 'この組織ではファイル添付が禁止されています'
          "
          :for="fileInputId"
          v-on:click="resetFile"
        >
          <b-icon-paperclip
            class="mr-1"
            font-scale="1.5"
            style="color: black"
          />ファイルをドロップまたは選択して添付
        </label>
        <b-form-file
          :id="fileInputId"
          :ref="fileInputId"
          v-model="target"
          :multiple="multiple ? true : undefined"
          :accept="accept()"
          :disabled="disabled"
          style="display: none"
          v-on:change="addFile"
        />
      </b-button>
    </div>

    <!-- PCレイアウト -->
    <div v-else class="d-flex flex-column">
      <div :class="`form-frame ${disabled ? 'not-allowed' : ''}`" for="fileInput">
        <label
          :class="`form-file-label ${disabled ? 'not-allowed' : ''}`"
          for="fileInput"
          v-on:click="resetFile"
          >ファイルをドロップまたは</label
        >
        <b-button
          :disabled="disabled"
          :class="`pc-file-form-button ${disabled ? 'not-allowed' : ''}`"
          size="sm"
        >
          <label
            class="d-flex align-items-center mb-0 p-1"
            v-b-popover.hover.top="
              allow_attachment ? '' : 'この組織ではファイル添付が禁止されています'
            "
            for="fileInput"
            v-on:click="resetFile"
            :style="attachementLabelStyle"
          >
            選択
          </label>
        </b-button>
        <b-form-file
          id="fileInput"
          ref="fileInput"
          v-model="target"
          :multiple="multiple ? true : undefined"
          :accept="contentType === 'TOPIC' ? accept(['image/*']) : accept()"
          :disabled="disabled"
          style="display: none"
          v-on:change="addFile"
        />
      </div>
    </div>
    <div v-if="fileNumberValidation" :class="`number-limit-label ${fileNumberValidation.class}`">
      {{ fileNumberValidation.label }}
    </div>

    <!-- 添付ファイル表示 -->
    <file-list-viewer
      v-if="files.length"
      :files="files"
      :thumbStore="thumbStore"
      class="my-2 file-list-viewer-style"
      :param="fileListViewerParams"
      v-on:deleteFile="deleteFile"
    />
  </b-form-group>
</template>

<style lang="scss">
.form-frame {
  display: flex;
  width: 100%;
  padding: 8px;
  border: 1px dashed #666666;
  border-radius: 5px;
  box-sizing: border-box;

  &.not-allowed {
    background: #eeeeee;
    border: 1px dashed #9d9d9d;
    cursor: not-allowed;
  }
}

.file-selection-form.attachment-link {
  display: flex;
  justify-content: center;
  color: #00b7c6;
  line-height: 1;
  &:hover {
    color: #00b7c6;
  }
}
.file-selection-form.attachment-link.not-allowed {
  color: gray;
}
.file-selection-form:hover,
.file-selection-form > label:hover {
  cursor: pointer;
}
.not-allowed:hover,
.not-allowed > label:hover {
  cursor: not-allowed;
}

.pc-file-form-button {
  justify-content: center;
  margin-right: 8px;
  background: #8ca6b7 !important;
  border-color: #8ca6b7 !important;
  line-height: 1;
  cursor: pointer;

  &.not-allowed {
    cursor: not-allowed;
    background: #e2e2e2 !important;
    border-color: #e2e2e2 !important;
    color: #b3b3b3;
  }
}

.form-file-label {
  display: flex;
  align-items: center;
  margin-bottom: 0px;
  margin-right: 4px;
  font-size: 16px;
  cursor: pointer;

  &.not-allowed {
    color: #bababa;
    cursor: not-allowed;
  }
}

.number-limit-label {
  display: flex;
  width: 100%;
  /* 直上のフォーカス枠（.btn:focus の box-shadow 0.2rem）が文言に重ならないよう余白を確保する */
  margin-top: 4px;
  font-size: 12px;

  &.warning {
    color: #ff976a;
  }
}

/* file-list-viewer の m-2 を打ち消すのと overflow 設定 */
.file-list-viewer-style {
  max-height: 240px; /* 4枚分の高さを確保する */
  overflow-y: auto;
  flex-wrap: nowrap;
  margin-left: 0 !important;
  margin-right: 0 !important;
}

.invisible-inputs {
  display: none;
}

.select-menu {
  max-width: 240px;
  margin: auto;

  ul {
    padding: 0;
    margin: 0;

    li {
      display: flex;
      align-items: center;
      padding-left: 20px;
      height: 44px;
    }
  }
}
</style>

<script lang="ts">
import { computed, defineComponent, ref, type PropType, type Ref } from "vue";
import { useAppStore, useDomainStore, useFileStore } from "@/store";
import path from "path";

import FileListViewer, {
  judgeType,
  getDenyMimeList,
  getAccept,
  getCaptureAccept,
  getVideoAccept,
} from "./FileListViewer.vue";
import { v4 as uuidv4 } from "uuid";

import S3AccessUtility from "./s3-acceess-utility";
import type { Attachment } from "../model/attachment";
import { AttachmentFactory } from "../model/attachment";

import type { AttachmentFileTypes } from "../suppport-attachment-types";
import { AttachmentFileTypesDefault, AttachmentFileTypesNone } from "../suppport-attachment-types";
import { OFFICE_TYPE_LIST } from "./file-utility";
import { UAParser } from "ua-parser-js";
import { BModal } from "bootstrap-vue";
import { useLegacyRootEvent } from "../composables/useLegacyRootEvent";

type ContenType = "TOPIC" | "MESSAGE" | "COMMENT";

export default defineComponent({
  name: "file-selection-form",
  components: { FileListViewer },
  props: {
    contentType: { type: String as PropType<ContenType>, default: "TOPIC", required: true },

    topicId: { type: String, default: undefined }, //!< 話題の添付ファイルの場合は指定。投稿／コメントの場合は指定無し
    messageId: { type: String, default: undefined }, //!< 投稿の添付ファイルの場合は指定。話題の場合は指定しない
    commentId: { type: String, default: undefined }, //!< コメントの添付ファイルの場合は指定。話題／投稿の場合は指定しない

    // フォームのラベル指定
    label: { type: String, default: "" },

    // 添付ファイル
    photos: { type: Array as PropType<Attachment[]>, default: () => [] },

    // true: 複数選択 false: 単一選択
    multiple: { type: Boolean, default: true },

    // ファイル添付設定
    allow_attachment_type: {
      // 元 @Prop は runtime type 引数なし（型注釈のみ）。検証を増やさないため type は付けない。
      default: () => AttachmentFileTypesDefault as AttachmentFileTypes,
    },

    // ファイル数上限
    fileNumberLimit: { type: Number, default: undefined },
  },
  setup(props, { emit }) {
    const rootEvent = useLegacyRootEvent();

    const target = ref<File | null>(null);
    const files = ref<(File | Attachment)[]>([]);
    const deletedFiles = ref<Attachment[]>([]); // 削除するファイル

    const denyMimeType = ref(["video/*", "application/pdf", ...OFFICE_TYPE_LIST]); //!< 添付に禁止するファイルタイプ (話題用)

    const dropLock = ref(false); // D&Dによる重複送信を防ぐ

    // template refs（旧 this.$refs.album / photo / video / showMenu）
    const album = ref<HTMLInputElement>();
    const photo = ref<HTMLInputElement>();
    const video = ref<HTMLInputElement>();
    const showMenu = ref<BModal>();

    // NOTE: getThumbStore は Pinia store の「関数」getter。旧コードは呼び出さずに関数自体を
    // 返しており、FileListViewer へ Function が渡る潜在バグだった（Vite/esbuild が
    // emitDecoratorMetadata を落とすため旧 @Prop では実行時型チェックが効かず無警告。
    // PR-2 の type: Array 明示で表面化）。関数を呼び出して File[] を渡す本来の挙動に修正。
    const thumbStore = computed((): File[] => {
      return useFileStore().getThumbStore();
    });

    const fileInputId = computed((): string => {
      const topicId = props.topicId || "";
      const messageId = props.messageId || "";
      const commentId = props.commentId || "";
      return `fileInput${topicId}${messageId}${commentId}`;
    });

    const cameraInputId = computed((): string => {
      const topicId = props.topicId || "";
      const messageId = props.messageId || "";
      const commentId = props.commentId || "";
      return `cameraInput${topicId}${messageId}${commentId}`;
    });

    // ファイルサイズ上限
    const fileSizeLimit = computed((): number => {
      return useDomainStore().getMaxFileSize as number;
    });

    // ファイルサイズ上限単位表記
    const fileSizeLimitUnit = computed((): string => {
      return useDomainStore().getFileSizeUnit as string;
    });

    const isMobile = computed((): boolean => {
      return useAppStore().isMobile;
    });

    // ファイルリストのパラメータ
    const fileListViewerParams = computed(
      (): { topicId?: string; messageId: string; commentId: string } => {
        if (props.topicId) {
          return { topicId: props.topicId, messageId: "", commentId: "" };
        } else if (props.messageId && !props.commentId) {
          return { messageId: props.messageId, commentId: "" };
        } else if (props.messageId && props.commentId) {
          return { messageId: props.messageId, commentId: props.commentId };
        } else {
          return { messageId: uuidv4(), commentId: uuidv4() };
        }
      }
    );

    // 添付可能か
    const allow_attachment = computed((): boolean => {
      return props.allow_attachment_type != AttachmentFileTypesNone;
    });

    const attachmentLinkClass = computed((): string => {
      return !disabled.value
        ? "file-selection-form attachment-link"
        : "file-selection-form attachment-link not-allowed";
    });

    const attachementLabelStyle = computed((): string => {
      return !disabled.value ? "cursor: pointer;" : "cursor: not-allowed;";
    });

    const fileNumberValidation = computed((): { label: string; class: string } | undefined => {
      if (!props.fileNumberLimit) {
        return undefined;
      } else {
        const diff = props.fileNumberLimit - files.value.length;
        if (diff === props.fileNumberLimit) {
          // 添付されていない
          return { label: `${props.fileNumberLimit}個まで添付できます`, class: "" };
        } else if (0 < diff) {
          // 上限数未満
          return { label: `あと${diff}個添付できます`, class: "" };
        } else {
          // 上限数添付・上限超過（超過時も添付不可の理由を表示する）
          return {
            label: `${files.value.length}/${props.fileNumberLimit}個添付しています`,
            class: "warning",
          };
        }
      }
    });

    /* フォームのdisabled */
    const disabled = computed((): boolean => {
      if (!allow_attachment.value) {
        return true;
      }
      // 上限ちょうど・上限超過のどちらも添付不可
      return !!props.fileNumberLimit && props.fileNumberLimit <= files.value.length;
    });

    // 拡張子設定
    const accept = (originAcceptList?: string[]): string => {
      return originAcceptList
        ? getAccept(props.allow_attachment_type, originAcceptList)
        : getAccept(props.allow_attachment_type);
    };

    // <input>にcaptureが指定されている時のaccept設定
    const captureAccept = (): string => {
      return getCaptureAccept(props.allow_attachment_type);
    };

    const videoAccept = (): string => {
      return getVideoAccept(props.allow_attachment_type);
    };

    /* ファイル一覧に追加 */
    const addFile = (e: { target: HTMLInputElement }): void => {
      const inputFiles = e.target.files;
      if (!inputFiles) return;
      pushFiles(inputFiles);
    };

    const pushFiles = (fileList_: FileList): void => {
      const fileList = Array.from(fileList_);

      // 単一選択時は複数選択されたとしても先頭のみを使う
      if (props.multiple) {
        const tmpFiles: (File | Attachment)[] = [];
        const fileArray: File[] = [];
        // エラー判定
        const result = judgeFilesProcess(fileList);

        if (result) {
          fileList.forEach((f) => {
            tmpFiles.push(f);
            fileArray.push(f);
          });

          tmpFiles.forEach((f) => files.value.push(f));
          useFileStore().pushThumbStore(fileArray);
        }
      } else if (1 <= fileList_.length) {
        // エラー判定
        const result = judgeFilesProcess(fileList);
        if (result) {
          if (fileList.length) {
            files.value.splice(0); // クリア
            files.value.push(fileList[0]);
          }
        }
      }
      emit("onUpdateThumb", files.value);
    };

    // 添付ファイルの削除
    const deleteFile = (index: number): void => {
      const file = files.value[index];
      if (AttachmentFactory.isAttachment(file)) {
        deletedFiles.value.push(file);
      }
      files.value.splice(index, 1);
      emit("onUpdateThumb", files.value);
    };

    // ファイル名の取得
    const getFileName = (file: File | Attachment): string => {
      if (AttachmentFactory.isAttachment(file)) {
        let fileStr = file.url;
        if (fileStr.slice(-1) == "/") {
          fileStr = fileStr.slice(0, -1);
        }
        const splitUrl = fileStr.split(path.sep);
        return S3AccessUtility.decodeName(splitUrl[splitUrl.length - 1]);
      } else {
        return file.name;
      }
    };

    // 追加されたファイル判定処理
    const judgeFilesProcess = (judgeFiles: File[]): boolean => {
      const originDenyList = props.contentType === "TOPIC" ? denyMimeType.value : [];

      // 1. 掲示板が対応していないファイルを選択した場合
      const typeErrorFiles = judgeFiles.filter((file) => !judgeType(file.type, originDenyList)); // 添付OKの場合で判定
      if (typeErrorFiles.length) {
        const fileNameList = typeErrorFiles.map((file) => {
          return file.name;
        });
        differentFileType(fileNameList);
        return false;
      }

      // 2. directの添付ファイル設定 (allow_attachment_type)に沿わない場合
      const denyList = getDenyMimeList(props.allow_attachment_type, originDenyList);
      const notAllowedFiles = judgeFiles.filter((file) => !judgeType(file.type, denyList)); // direct組織設定に沿って判定
      if (notAllowedFiles.length) {
        const fileNameList = notAllowedFiles.map((file) => {
          return file.name;
        });
        noAllowedFileType(fileNameList);
        return false;
      }

      // 3. 添付可能ファイル数を超えてた場合
      if (
        props.multiple &&
        props.fileNumberLimit &&
        judgeFiles.length > props.fileNumberLimit - files.value.length
      ) {
        // *複数添付可能な時のみ判定する
        overFileNumber();
        return false;
      }

      // 4. ファイルサイズ上限を超えた場合
      const sizeOverFiles = judgeFiles.filter((file) => file.size > fileSizeLimit.value);
      if (sizeOverFiles.length) {
        const fileNameList = sizeOverFiles.map((file) => {
          return file.name;
        });
        overFileSize(fileNameList);
        return false;
      }

      return true;
    };

    /* ファイルエラーイベント */

    // 掲示板に対応しているか
    const differentFileType = (fileNameList: string[]): void => {
      const errorMsg = `下記の添付ファイルは対応しておりません。\n\n${fileNameList.join("\n")}`;
      rootEvent.emit("show-error-modal", {
        msg: errorMsg,
        afterProcess: () => {
          return;
        },
      });
    };

    // direct組織での禁止
    const noAllowedFileType = (fileNameList: string[]): void => {
      const errorMsg = `下記のファイルは組織設定で許可しているファイル形式と異なるため添付できません。\n\n${fileNameList.join("\n")}`;
      rootEvent.emit("show-error-modal", {
        msg: errorMsg,
        afterProcess: () => {
          return;
        },
      });
    };

    // ファイル数が上限オーバー
    const overFileNumber = (): void => {
      if (!props.fileNumberLimit) {
        return;
      }
      rootEvent.emit("show-error-modal", {
        msg: `添付できるファイルは${props.fileNumberLimit}個までです。`,
        afterProcess: () => {
          return;
        },
      });
    };

    // ファイルサイズ上限オーバー
    const overFileSize = (fileNameList: string[]): void => {
      const errorMsg = `下記のファイルは${fileSizeLimitUnit.value}を超えているため添付できません。\n\n${fileNameList.join("\n")}`;
      rootEvent.emit("show-error-modal", {
        msg: errorMsg,
        afterProcess: () => {
          return;
        },
      });
    };

    // 同じファイルを連続で送るためのリセット
    const resetFile = (): void => {
      target.value = null;
    };

    // fileListViewerにセットされたデータリセット
    const resetFileList = (): void => {
      files.value = [];
      target.value = null;
    };

    // D&D処理
    const dropFiles = (dropped: FileList): void => {
      if (!dropLock.value) {
        dropLock.value = true;
        pushFiles(dropped);
        setTimeout(() => (dropLock.value = false), 500); // 500ms後にD&D受付再開
      }
    };

    const clickMobile = (): void => {
      // ハンドラは <b-button> ではなく内側の <label> に付いているため、ボタンが
      // disabled でも実機ではタップが通る。ここで明示的に抑止する。
      if (disabled.value) {
        return;
      }

      // iOS、PC、画像・動画が添付不可の場合、メニューは出さずに、ファイルから選択と同じ処理を行います。
      const uaParser = new UAParser();
      const device = uaParser.getDevice();
      const isShowMenu = props.allow_attachment_type.image || props.allow_attachment_type.movie;

      if (device.vendor == "Apple" || device.type !== "mobile" || !isShowMenu) {
        const albumInput = album.value;
        if (albumInput) {
          albumInput.value = ""; // リセット
          albumInput.click();
        }
      } else {
        const modal = showMenu.value;
        modal?.show();
      }
    };

    const menuSelected = (id: string): void => {
      // 旧 this.$refs[id]（id は 'album' | 'photo' | 'video'）の動的参照を
      // template ref のマップで置き換える
      const inputRefs: Record<string, Ref<HTMLInputElement | undefined>> = { album, photo, video };
      // メニュー表示中に添付不可へ変わった場合は input を起動せず、メニューを閉じるだけにする
      const input = disabled.value ? undefined : inputRefs[id]?.value;
      if (input) {
        input.value = ""; // リセット
        input.click();
      }
      const modal = showMenu.value;
      modal?.hide();
    };

    // Lifecycle（created 相当）
    if (props.photos.length) {
      files.value = props.photos.slice();
    }

    return {
      target,
      files,
      deletedFiles,
      denyMimeType,
      dropLock,
      album,
      photo,
      video,
      showMenu,
      thumbStore,
      fileInputId,
      cameraInputId,
      fileSizeLimit,
      fileSizeLimitUnit,
      isMobile,
      fileListViewerParams,
      allow_attachment,
      attachmentLinkClass,
      attachementLabelStyle,
      fileNumberValidation,
      disabled,
      accept,
      captureAccept,
      videoAccept,
      addFile,
      pushFiles,
      deleteFile,
      getFileName,
      judgeFilesProcess,
      differentFileType,
      noAllowedFileType,
      overFileNumber,
      overFileSize,
      resetFile,
      resetFileList,
      dropFiles,
      clickMobile,
      menuSelected,
    };
  },
});
</script>
